import {
  OUTPUTS_LOGS,
  OUTPUTS_DURATION,
  OUTPUTS_ENQUADRAMENTO,
  OUTPUTS_VAR,
  OUTPUTS_DOWNLOAD,
  OUTPUTS_PREVIEW,
  OUTPUTS_LOGS_DELETE,
  OUTPUTS_CACHE,
  OUTPUTS_CACHE_LIST,
  OUTPUTS_ENUM,
  OUTPUTS_CACHE_DELETE,
  OUTPUTS_CACHE_DOWNLOAD,
} from "../const/servicesURI";
import requestService from "./requestService";
import utils from "../utils";

// Logs
export const logs = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: {
      sort: "log_id DESC, data_posicao",
      excluido: false,
      ...pParams,
    },
  };

  return requestService(xProps, OUTPUTS_LOGS, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Carteiras List");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const removeLogs = (pLogId, pResolve, pReject, pFinally) => {
  const xProps = {
    data: {
      log_id: pLogId,
    },
    method: "delete",
  };

  return requestService(xProps, OUTPUTS_LOGS_DELETE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Logs Remove");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

// Duration
export const duration = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
  };

  return requestService(xProps, OUTPUTS_DURATION, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Output Duration");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

// Enquadramento
export const enquadramento = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
  };

  return requestService(xProps, OUTPUTS_ENQUADRAMENTO, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Output Enquadramento");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

// VaR
export const risco = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
  };

  return requestService(xProps, OUTPUTS_VAR, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Carteiras Read");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

// Download
export const download = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
    responseType: "blob",
  };

  return requestService(xProps, OUTPUTS_CACHE_DOWNLOAD, 3, 2400, true)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Outputs Download");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

// Preview
export const preview = (pLogId, pResolve, pReject, pFinally) => {
  const xProps = {
    params: {
      log_id: pLogId,
    },
    responseType: "blob",
  };

  return requestService(xProps, OUTPUTS_PREVIEW, 3, 2400, true)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Outputs Preview");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const cache = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, OUTPUTS_CACHE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Output Cache");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const cacheList = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, OUTPUTS_CACHE_LIST, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Output Cache List");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const cacheRemove = (pOutputCacheId, pResolve, pReject, pFinally) => {
  const xProps = {
    data: {
      output_cache_id: pOutputCacheId,
    },
    method: "delete",
  };

  return requestService(xProps, OUTPUTS_CACHE_DELETE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Output Cache Delete");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const enumaration = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, OUTPUTS_ENUM, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Output Enum");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const entidades = {
  logs,
  removeLogs,
  duration,
  risco,
  download,
  preview,
  enquadramento,
  cache,
  enumaration,
  cacheList,
  cacheRemove,
};

export default entidades;
